import { ProgramEntity } from '@/modules/programs/domain/entities/ProgramEntity';
import {
  BlockFormats,
  BlockInitializer,
  BlockSizes,
  ContentTypes,
  Program,
  Typology,
} from '@/types';

export class BlockEntity {
  UUID?: string;
  contentType?: ContentTypes;
  format: BlockFormats;
  size: keyof typeof BlockSizes;
  items: Program[];
  populated?: boolean;
  randomOrder?: number;
  title: string;
  type?: string;

  constructor(homepage: Partial<BlockInitializer>) {
    this.UUID = homepage.UUID;
    this.contentType = homepage.contentType;
    this.format = homepage.format;
    this.size = this.toSize(homepage.format);
    this.items = (homepage.items || []).map(
      (item) => new ProgramEntity(item) as unknown as Program
    );
    this.populated = homepage.populated || true;
    this.randomOrder = homepage.randomOrder || 0;
    this.title = homepage.title || 'TITLE';
    this.type = homepage.type || Typology.Editorial;
  }

  toSize(blockFormat: BlockFormats): keyof typeof BlockSizes {
    switch (blockFormat) {
      case BlockFormats.HeaderCarousel:
        return 'header';
      case BlockFormats.HighCarousel:
      case BlockFormats.LargeCarousel:
      case BlockFormats.Large:
        return 'default';
      case BlockFormats.Progress:
        return 'progress';
      case BlockFormats.Ad:
        return 'ad';
      default:
        return 'default';
    }
  }
}
